module.exports = __webpack_public_path__ + "media/1.1c16d471.mp3";